const toolTip = document.querySelector('tool-tip');
const toolTipTrigger = document.querySelector('.tool-tip-trigger__title');
let inch_button, cm_button, size_chart;

if (toolTipTrigger) {
  //Observe toolTip element for changes when tool tip is clicked
  toolTipTrigger.addEventListener('click', () => {
    sizeChartObserver.observe(toolTip, { attributes: true });
  });
  
  //add EventListeners to buttons/menu-items in tool-tip when it is opened
  const sizeChartObserver = new MutationObserver((mutations) => {
    
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'data-tool-tip-open') {
        inch_button = mutation.target.querySelector('.unit-in');
        cm_button = mutation.target.querySelector('.unit-cm');
        size_chart = mutation.target.querySelector('.size-chart');
        
        inch_button.addEventListener('click', switchUnit);
        cm_button.addEventListener('click', switchUnit);
        sizeChartObserver.disconnect();
      }
    });
  });
} else {
  inch_button = document.querySelector('.unit-in');
  cm_button = document.querySelector('.unit-cm');
  size_chart = document.querySelector('.size-chart');
  inch_button.addEventListener('click', switchUnit);
  cm_button.addEventListener('click', switchUnit);
}

// changes header to to display unit type
function changeHeaderUnits(unit) {
    const cells = size_chart.rows[0].cells;
    for (let i = 0; i < cells.length; i++) {
      const header = cells[i].textContent.split('(');
      const headerUnit = unit === 'in' ? '(In.)' : '(Cm.)';
      cells[i].textContent = header.length > 1 ? `${header[0]} ${headerUnit}` : `${header[0]}`
    }
};
let inConverted = false;
const sizesInInches = [];

// changes table data corresponding to the unit the user selects
function toggleDataUnits(unit) {
  const rows = size_chart.rows;
  for (let i = 1; i < rows.length; i++) {
    const cells = rows[i].cells;
    const rowData = [];
    for (let j = 1; j < cells.length; j++) {
      const text = cells[j].textContent;
      if (inConverted === false) {
        rowData.push(text);
      }
      if (unit === 'in') {
        cells[j].textContent = sizesInInches[i-1][j-1];
      } else {
        const measurementRange = text.split('-');
        let lowerRangeValue = parseFloat(measurementRange[0]) * 2.54;
        let upperRangeValue = measurementRange[1] ? parseFloat(measurementRange[1]) * 2.54 : undefined;
        let value;
        if (upperRangeValue) {
          value = `${Math.round(lowerRangeValue)} - ${Math.round(upperRangeValue)}`;
        } else {
          value = Math.round(lowerRangeValue);
        }
        cells[j].textContent = value;
      }
    }
    if (rowData.length) {
      sizesInInches.push(rowData);
    }
  }
  inConverted = true;
};


// changes active status of buttons, and changes table headers and data depending on unit selected by user
function switchUnit(e) {
  const clickedButton = e.target;
  if (clickedButton.textContent === 'IN' && cm_button.classList.contains('active')) {
    inch_button.classList.toggle('active');
    cm_button.classList.toggle('active');
    changeHeaderUnits('in');
    toggleDataUnits('in');
  } else if (clickedButton.textContent === 'CM' && inch_button.classList.contains('active')) {
    inch_button.classList.toggle('active');
    cm_button.classList.toggle('active');
    changeHeaderUnits('cm');
    toggleDataUnits('cm');
  }  
}